import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReverseAuctionConsumer from "./ReverseAuctionConsumer";
import ReverseAuctionGenerator from "./ReverseAuctionGenerator";
import AuctionPageDashboard from "../AuctionPageDashboard";
import {
  auctionBidders,
  auctionBiddersRa,
  auctionGet,
} from "../../../../../Redux/Slices/auctionSlice";
import { useLocation } from "react-router-dom";
const LiveReverseAuctionOngoing = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const dispatch = useDispatch();

  useEffect(() => {
    getAuction();
  }, []);

  const getAuction = () => {
    if (role === "consumer") {
      dispatch(auctionGet());
    } else if (role === "generator") {
      dispatch(auctionBiddersRa());
    }
  };

  return (
    <>
      {role === "consumer" ? (
        <ReverseAuctionConsumer />
      ) : role === "generator" ? (
        <ReverseAuctionGenerator />
      ) : (
        <AuctionPageDashboard />
      )}
    </>
  );
};

export default LiveReverseAuctionOngoing;
